import {withTranslation} from 'react-i18next';

const Copyright = ({t}) => {
  return t('login.copyright', {date: new Date().getFullYear()});
};

export default withTranslation('login')(Copyright);
